import 'swiper/swiper-bundle.css';
import {useAtom} from 'jotai';
import {selectedNearbyInfoItemCardAtom} from '@/map/atom';
import {Swiper, SwiperSlide} from '../Swiper';
import {NearbyInfoCard} from './NearbyInfoCard';

export const NearbyInfoCards = ({hidden}: {hidden: boolean}) => {
  const [card] = useAtom(selectedNearbyInfoItemCardAtom);

  if (!card) {
    return null;
  }

  return (
    <Swiper hidden={hidden}>
      <SwiperSlide>
        <NearbyInfoCard {...card} />
      </SwiperSlide>
    </Swiper>
  );
};
